import React from 'react';

import Select, { StylesConfig } from '@atlaskit/select';
import { layers } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import isMobile from 'src/components/sidebar/src/is-mobile';
import { useIntl } from 'src/hooks/intl';

import {
  FilterOptions,
  SelectableFilterOptions,
  VISIBLE_FILTER_OPTIONS,
} from './constants';
import messages, {
  filterLabels,
} from './pull-request-overview-activity-filter.i18n';
import { StateOptionType } from './types';

type Props = {
  onChangeState: (option: FilterOptions) => void;
  isDisabled: boolean;
  /* eslint react/no-unused-prop-types: "warn" */
  uuid?: string;
};

const styles: StylesConfig = {
  control: css => ({
    ...css,
    border: !isMobile() ? 'none' : css.border,
  }),
  placeholder: css => ({
    ...css,
    color: token('color.text'),
    fontWeight: token('font.weight.medium'),
  }),
  singleValue: css => ({
    ...css,
    fontWeight: token('font.weight.medium'),
  }),
  menu: css => ({
    ...css,
    zIndex: layers.modal(),
  }),
};

export const PullRequestOverviewActivityFilter = ({
  onChangeState,
  isDisabled,
}: Props) => {
  const intl = useIntl();
  const filterOptions: StateOptionType[] = VISIBLE_FILTER_OPTIONS.map(
    (key: SelectableFilterOptions): StateOptionType => ({
      label: intl.formatMessage(filterLabels[key]),
      value: key,
    })
  );

  const onChange = (option: StateOptionType) => {
    onChangeState(
      option && option.value ? option.value : FilterOptions.SHOW_ALL
    );
  };

  return (
    <Select
      isClearable
      blurInputOnSelect
      placeholder={intl.formatMessage(messages.filterPlaceholder)}
      appearance="default"
      options={filterOptions}
      isSearchable={false}
      isDisabled={isDisabled}
      styles={styles}
      spacing="compact"
      onChange={onChange}
    />
  );
};
